import React from 'react'

const CardReaderConnected = () => {
  const styles = {
    display: 'block',
    flexGrow: 0,
    flexShrink: 0,
    marginTop: 3,
    marginBottom: 3,
    marginLeft: 2,
  }

  return (
    <svg style={styles} width="20px" height="16px" viewBox="0 0 20 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Badge-/-Card-/-Connected" transform="translate(-16.000000, -14.000000)" fill="#000000" fillRule="nonzero">
          <path d="M34,14 L18,14 C16.89,14 16.01,14.89 16.01,16 L16,28 C16,29.11 16.89,30 18,30 L34,30 C35.11,30 36,29.11 36,28 L36,16 C36,14.89 35.11,14 34,14 Z M34,28 L18,28 L18,22 L34,22 L34,28 Z M34,18 L18,18 L18,16 L34,16 L34,18 Z" id="card-reader-available"></path>
        </g>
      </g>
    </svg>
  )
}

export default CardReaderConnected
